<template>
  <div>
    <Header :title="headerTitle" :home-button="showHomeButton" />
    <router-view
      v-bind="{ ...$attrs, ...$props }"
      :documents="apiDocs"
      :doc-url="selectedApi ? selectedApi.swaggerUrl : ''"
      @select-document="selectApi"
    ></router-view>
  </div>
</template>

<script>
import documents from "@/documents";
import Header from "@/components/Header";

export default {
  name: "Home",
  components: {
    Header
  },
  data() {
    return {
      apiDocs: documents,
      selectedApi: null
    };
  },
  computed: {
    headerTitle() {
      return this.selectedApi ? this.selectedApi.name : "API Documentation";
    },
    routeApiName() {
      return this.$route.params.apiName;
    },
    showHomeButton() {
      let currentRoute = this.$route.name;

      if (currentRoute !== "API Documentation List") return true;

      return false;
    }
  },
  methods: {
    init() {
      if (this.routeApiName) this.selectApi(this.routeApiName);
    },
    selectApi(name) {
      // find api obj and set selected API
      let foundApi = this.apiDocs.filter(doc => {
        return doc.name === name;
      })[0];

      if (!foundApi) return;

      this.selectedApi = foundApi;

      // update route to new API Doc w/ proper
      //   this.$router.push(`/api/${foundApi.name}/documentation`);
    }
  },
  mounted() {
    this.init();
  }
};
</script>
